"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wallet = void 0;
const api_actions_enum_1 = require("./constants/api-actions.enum");
class Wallet {
    constructor(messages) {
        this.messages = messages;
    }
    /**
     * Returns user's account information, like account address and
     * ENS name (if available).
     * @returns AccountInfo object
     */
    getAccountInfo() {
        return this.messages.sendMessage(api_actions_enum_1.ApiActions.GET_USER_INFO);
    }
    /**
     * Returns account balance of current user in wei
     * @returns current balance in wei
     */
    getUserBalance() {
        return this.messages.sendMessage(api_actions_enum_1.ApiActions.GET_USER_BALANCE);
    }
    /**
     * Creates a transaction with current user as signer.
     * @param address receiver account
     * @param value transaction value in wei
     */
    sendTransaction(address, value) {
        return this.messages.sendMessage(api_actions_enum_1.ApiActions.SEND_TRANSACTION, { to: address, value });
    }
}
exports.Wallet = Wallet;
